import React from "react";
import { Box } from "@mui/material";

function MainContent(props) {
  const { sx, children } = props;

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        flexGrow: 1,
        display: "flex",
        gap: "10px",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default MainContent;
